<template>
  <ImageBar 
    title="访问"
    imageUrl="https://picsum.photos/1200/500?random=3"
    height="80px"
  />

  <div class="dating-container">
    <div class="tab-navigation">
      <el-tabs :model-value="activeTab" @tab-click="handleTabClick">
        <el-tab-pane name="visitedme">
          <template #label>
            <div class="tab-label">
              <span>看我的人</span>
              <el-button type="primary" text @click.stop="refreshVisitedMe">
                <el-icon><Refresh /></el-icon>
              </el-button>
            </div>
          </template>
        </el-tab-pane>
        <el-tab-pane name="visited">
          <template #label>
            <div class="tab-label">
              <span>我看过的人</span>
              <el-button type="primary" text @click.stop="refreshVisited">
                <el-icon><Refresh /></el-icon>
              </el-button>
            </div>
          </template>
        </el-tab-pane>
      </el-tabs>
    </div>

    <div class="search-bar">
      <el-input
        v-model="searchQuery"
        placeholder="查找姓名、年龄、城市"
        class="search-input"
        clearable
        @clear="handleSearch"
        @input="handleSearch"
      >
        <template #prefix>
          <el-icon><Search /></el-icon>
        </template>
      </el-input>
    </div>

    <div class="dating-grid" v-loading="loading">
      <div v-for="person in peopleList" :key="person.uuid" class="profile-card">
        <div class="profile-photo" @click="viewPerson(person.uuid)">
          <el-image 
            :src="person.photo" 
            fit="cover"
            class="profile-image"
          >
            <template #error>
              <div class="image-placeholder">
                <el-icon><User /></el-icon>
              </div>
            </template>
          </el-image>
          <div class="profile-overlay">
            <div class="profile-basic">
              <h3>{{ person.name }}</h3>
              <div class="age-location">
                <span>{{ person.age }}岁</span>
                <el-divider direction="vertical" />
                <span>{{ person.location }}</span>
              </div>
            </div>
            <div class="profile-tags">
              <el-tag size="small" type="success">{{ person.height }}cm</el-tag>
              <el-tag size="small" type="warning">{{ person.occupation }}</el-tag>
              <el-tag size="small" type="info">{{ person.education }}</el-tag>
              <el-tag size="small" type="danger">访问{{ person.times || 0 }}次</el-tag>
            </div>
          </div>
        </div>
        
        <div class="profile-actions">
          <el-button type="primary" text @click="viewPerson(person.uuid)">
            查看详情
          </el-button>
          <el-button type="success" text @click="startChat(person.uuid)">
            聊天
          </el-button>
          <el-button type="danger" text @click="likePerson(person.uuid)">
            <el-icon><Star /></el-icon>
          </el-button>
          <el-button type="danger" text @click="addToBlacklist(person.uuid)">
            <el-icon><CircleClose /></el-icon>
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Search, User, Star, Refresh, CircleClose } from '@element-plus/icons-vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import ImageBar from './components/ImageBar.vue'
import { resolveProfilePhotoUrl } from '@/utils/photoUpload'
import { markProfileUnlockReminded } from '@/utils/profileUnlock'

export default {
  name: 'VisiteView',
  components: {
    Search,
    User,
    Star,
    Refresh,
    CircleClose,
    ImageBar
  },
  data() {
    return {
      loading: false,
      visitedMeList: [],
      visitedList: [],
      currentPage: 1,
      pageSize: 12,
      total: 0,
      searchQuery: '',
      searchTimer: null,
      activeTab: 'visitedme'
    }
  },
  computed: {
    peopleList() {
      return this.activeTab === 'visitedme' ? this.visitedMeList : this.visitedList
    }
  },
  created() {
    const tab = this.$route.query.tab
    if (tab === 'visited' || tab === 'visitedme') {
      this.activeTab = tab
    }
  },
  watch: {
    '$route.query.tab'(tab) {
      if (tab === 'visited' || tab === 'visitedme') {
        this.activeTab = tab
      }
    },
    activeTab: {
      immediate: true,
      handler(newTab) {
        this.searchQuery = ''
        this.currentPage = 1
        if ((newTab === 'visitedme' && this.visitedMeList.length === 0) ||
            (newTab === 'visited' && this.visitedList.length === 0)) {
          this.fetchPeopleList()
        }
      }
    }
  },
  methods: {
    async fetchPeopleList() {
      this.loading = true
      try {
        const token = localStorage.getItem('jwt_token')
        const endpoint = this.activeTab === 'visitedme' ? '/api/v1/visitedme/list' : '/api/v1/visited/list'
        
        const response = await fetch(endpoint, {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            page: this.currentPage,
            pageSize: this.pageSize,
            keyword: this.searchQuery
          })
        })

        const data = await response.json()
        if (data.code === 200) {
        //   const list = this.activeTab === 'visitedme' ? data.data.visitedMe : data.data.visited
          const list = data.data.visited
          const formattedList = list.map(user => ({
            uuid: user.uuid,
            name: user.nickname || user.username,
            age: user.age || 0,
            location: user.city || '未知',
            height: user.height || 0,
            occupation: user.occupation || '未知',
            education: user.education || '未知',
            photo: resolveProfilePhotoUrl(user.avatar, user.photo) || 'https://example.com/default-avatar.jpg',
            interests: user.hobbies || [],
            description: user.introduction || '',
            times: user.times || 0
          }))
          
          if (this.activeTab === 'visitedme') {
            this.visitedMeList = formattedList
          } else {
            this.visitedList = formattedList
          }
          this.total = data.data.total
        } else {
          ElMessage.error(data.message || '获取用户列表失败')
        }
      } catch (error) {
        ElMessage.error('获取用户列表失败')
        console.error(error)
      } finally {
        this.loading = false
      }
    },
    handleTabClick(tab) {
      this.activeTab = tab.props.name
    },
    refreshVisitedMe() {
      this.activeTab = 'visitedme'
      this.currentPage = 1
      this.forceFetchPeopleList()
    },
    refreshVisited() {
      this.activeTab = 'visited'
      this.currentPage = 1
      this.forceFetchPeopleList()
    },
    async forceFetchPeopleList() {
      this.loading = true
      try {
        const token = localStorage.getItem('jwt_token')
        const endpoint = this.activeTab === 'visitedme' ? '/api/v1/visitedme/list' : '/api/v1/visited/list'
        
        const response = await fetch(endpoint, {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            page: this.currentPage,
            pageSize: this.pageSize,
            keyword: this.searchQuery
          })
        })

        const data = await response.json()
        if (data.code === 200) {
          ///const list = this.activeTab === 'visitedme' ? data.data.visitedMe : data.data.visited
          const list = data.data.visited
          const formattedList = list.map(user => ({
            uuid: user.uuid,
            name: user.nickname || user.username,
            age: user.age || 0,
            location: user.city || '未知',
            height: user.height || 0,
            occupation: user.occupation || '未知',
            education: user.education || '未知',
            photo: resolveProfilePhotoUrl(user.avatar, user.photo) || 'https://example.com/default-avatar.jpg',
            interests: user.hobbies || [],
            description: user.introduction || '',
            times: user.times || 0
          }))
          
          if (this.activeTab === 'visitedme') {
            this.visitedMeList = formattedList
          } else {
            this.visitedList = formattedList
          }
          this.total = data.data.total
        } else {
          ElMessage.error(data.message || '获取用户列表失败')
        }
      } catch (error) {
        ElMessage.error('获取用户列表失败')
        console.error(error)
      } finally {
        this.loading = false
      }
    },
    handleSearch() {
      if (this.searchTimer) {
        clearTimeout(this.searchTimer)
      }
      this.searchTimer = setTimeout(() => {
        this.currentPage = 1
        this.forceFetchPeopleList()
      }, 300)
    },
    viewPerson(uuid) {
      const person = this.peopleList.find(p => p.uuid === uuid)
      if (person && person.photo && person.photo.includes('blur')) {
        ElMessageBox.confirm(
          '你还没访问过该用户，查看需要扣除10分，是否继续查看？',
          '提示',
          {
            confirmButtonText: '继续查看', 
            cancelButtonText: '取消',
            type: 'warning'
          }
        ).then(() => {
          markProfileUnlockReminded(uuid)
          this.$router.push(`/profile/${uuid}`)
        }).catch(() => {
          // User cancelled, do nothing
        })
      } else {
        this.$router.push(`/profile/${uuid}`)
      }
    },
    startChat() {
      ElMessage.info('私信功能暂未开放')
    },
    async likePerson(uuid) {
      try {
        const token = localStorage.getItem('jwt_token')
        const response = await fetch('/api/v1/user/like', {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            targetUuid: uuid,
            likeLevel: 1
          })
        })

        const data = await response.json()
        if (data.code === 200) {
          ElMessage.success('已添加到喜欢列表')
          // Refresh the current list to reflect changes
          this.forceFetchPeopleList()
        } else {
          ElMessage.error(data.message || '操作失败')
        }
      } catch (error) {
        ElMessage.error('操作失败')
        console.error(error)
      }
    },
    async addToBlacklist(uuid) {
      try {
        const token = localStorage.getItem('jwt_token')
        const response = await fetch('/api/v1/user/blacklist/add', {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            targetUuid: uuid
          })
        })

        const data = await response.json()
        if (data.code === 200) {
          ElMessage.success('已添加到黑名单')
          this.fetchPeopleList()
        } else {
          ElMessage.error(data.message || '添加到黑名单失败')
        }
      } catch (error) {
        ElMessage.error('添加到黑名单失败')
        console.error(error)
      }
    }
  }
}
</script>

<style scoped>
.dating-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 20px;
}

.tab-navigation {
  margin-bottom: 20px;
}

.search-bar {
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
}

.search-input {
  width: 300px;
}

.dating-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 24px;
  margin-bottom: 20px;
}

@media (max-width: 767px) {
  .dating-container {
    padding: 0;
  }

  .tab-navigation {
    margin-bottom: 8px;
    padding: 0 8px;
  }

  .dating-grid {
    gap: 8px;
    margin-bottom: 8px;
  }
}

.profile-card {
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
  transition: all 0.3s;
}

.profile-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}

.profile-photo {
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: 125%;
  cursor: pointer;
}

.profile-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s;
}

.profile-image:hover {
  transform: scale(1.05);
}

.profile-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 16px;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.8), transparent);
  color: #fff;
}

.profile-basic h3 {
  margin: 0 0 8px 0;
  font-size: 1.2rem;
  color: #fff;
}

.age-location {
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.9);
}

.profile-tags {
  display: flex;
  gap: 8px;
  margin-top: 8px;
  flex-wrap: wrap;
}

.profile-actions {
  position: absolute;
  top: 16px;
  right: 16px;
  display: flex;
  gap: 8px;
}

.profile-actions .el-button {
  background: rgba(255,255,255,0.85);
  color: #333;
  font-weight: bold;
  border: none;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
  transition: background 0.2s, color 0.2s;
}

.profile-actions .el-button:hover {
  background: #fff;
  color: #409EFF;
}

.image-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f5f7fa;
  color: #909399;
  font-size: 30px;
}

.tab-label {
  display: flex;
  align-items: center;
  gap: 8px;
}

.tab-label span {
  cursor: pointer;
}

.tab-label .el-button {
  padding: 0;
  margin-left: 4px;
}
</style> 